module.exports = __webpack_public_path__ + "img/home_bnews6_1.3bd02338.jpeg";